import { getJson } from './http';

export type UpcomingHoliday = { name: string; date: string };

export async function fetchUpcomingHolidays(params: { days?: number }, signal?: AbortSignal): Promise<UpcomingHoliday[]> {
  const raw = await getJson<any>('/holidays/upcoming', params as any, signal);
  let data: any = raw;
  if (typeof raw === 'string') {
    try { data = JSON.parse(raw); } catch { data = []; }
  }
  if (Array.isArray(data)) {
    return data as UpcomingHoliday[];
  }
  if (data && Array.isArray(data.payload)) return data.payload as UpcomingHoliday[];
  return [];
}
